export default __webpack_public_path__ + "images/EQ.5cda66e.png";